module.exports = __webpack_public_path__ + "img/2834b9f992cb7148f267aa816d41a496.png";